(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1350],{

/***/ 51704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(52153);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 52153:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 54073:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(29259),
    now = __webpack_require__(61100),
    toNumber = __webpack_require__(7642);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 61100:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(37772);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 7642:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(51704),
    isObject = __webpack_require__(29259),
    isSymbol = __webpack_require__(4795);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 45971:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/non-benefit",
      function () {
        return __webpack_require__(18215);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 13805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ DOCTOR_NOW_COMPANY_LATITUDE; },
/* harmony export */   "y": function() { return /* binding */ DOCTOR_NOW_COMPANY_LONGITUDE; }
/* harmony export */ });
var DOCTOR_NOW_COMPANY_LATITUDE = 37.4995535963247;
var DOCTOR_NOW_COMPANY_LONGITUDE = 127.025752388871;


/***/ }),

/***/ 72105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _models_ad_list__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70847);
/* harmony import */ var _recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15951);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53476);
/* harmony import */ var _ad_useAdBanner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28844);





var useAppInstallTopBanner = function(client) {
    var isVisible = (0,recoil__WEBPACK_IMPORTED_MODULE_3__.useRecoilValue)(_recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_1__/* .appInstallTopBannerState */ .Ep).isVisible;
    var ref = (0,_ad_useAdBanner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_models_ad_list__WEBPACK_IMPORTED_MODULE_0__/* .AdPageType.TopCtaBand */ .hO.TopCtaBand, client, true), bannerAdExchange = ref.bannerAdExchange, handleSendExposureLog = ref.handleSendExposureLog;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        (0,_recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_1__/* .getAppInstallTopBannerState */ ._l)();
    }, []);
    return {
        bannerAdExchange: bannerAdExchange,
        handleSendExposureLog: handleSendExposureLog,
        isVisible: isVisible,
        hideBanner: _recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_1__/* .hideBanner */ .dl
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useAppInstallTopBanner);


/***/ }),

/***/ 38245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Oy": function() { return /* binding */ useSearchKoreaAddressV2Query; },
/* harmony export */   "Yx": function() { return /* binding */ useDoctorReviewMetricQuery; },
/* harmony export */   "dr": function() { return /* binding */ useGetHospitalByIdQuery; },
/* harmony export */   "hh": function() { return /* binding */ useGetAddressByLocationQuery; },
/* harmony export */   "nR": function() { return /* binding */ useGetTotalReviewCountWithAverageRatingByPublicIdQuery; },
/* harmony export */   "xK": function() { return /* binding */ useGetUserAddressesQuery; }
/* harmony export */ });
/* unused harmony exports GetHospitalByIdDocument, DoctorReviewMetricDocument, GetFaceToFaceDiagnosisBookingFormByPublicIdDocument, useGetFaceToFaceDiagnosisBookingFormByPublicIdQuery, GetTotalReviewCountWithAverageRatingByPublicIdDocument, GetAddressByLocationDocument, GetUserAddressesDocument, SearchKoreaAddressV2Document, HospitalExternalPostDocument, useHospitalExternalPostQuery */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36492);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);


var GetHospitalByIdDocument = "\n    query GetHospitalById($publicId: String!) {\n  getHospitalByPublicId(publicId: $publicId) {\n    id\n    name\n    isBookable\n    isTodayBookable\n    partnershipTemplate\n    profileImages {\n      url\n      isRepresentative\n    }\n    badges\n    naverPlaceDetail {\n      hashtags\n      treatmentMenus {\n        treatmentName\n        price\n      }\n    }\n    temporaryHolidaysNotice\n    temporaryHolidays\n    todayDuty {\n      dayOfWeek\n      openTime\n      closeTime\n      breakStartTime\n      breakEndTime\n      operationTimes\n      breakTimes\n      isClosed\n      operatingStatus\n    }\n    duties {\n      dayOfWeek\n      openTime\n      closeTime\n      breakStartTime\n      breakEndTime\n      operationTimes\n      breakTimes\n      isClosed\n    }\n    departmentsV2 {\n      departmentId\n      departmentName\n    }\n    departmentGroups {\n      averageRating\n      departmentGroupId\n      departmentGroupName\n      departmentGroupIconUrl\n      tags\n    }\n    nonBenefitDiagnosisPrices {\n      middleCategoryName\n      minPrice\n      maxPrice\n    }\n    longitude\n    latitude\n    jibunAddress\n    roadAddress\n    detailAddress\n    directionGuidance\n    parkingInformation\n    isFreeParking\n    tel\n    viewCount\n    introduction\n    regionByDepth {\n      siDoName\n      siGunGuName\n      eupMyeonDongName\n    }\n    treatments {\n      id\n      name\n    }\n    hospitalAdBanners {\n      displayDiscount\n      displayPrice\n      id\n      thumbnailImageUrl\n      title\n      url\n      hospitalId\n    }\n    hospitalSurgeries {\n      surgeryCount\n      surgeryName\n      badges\n      id\n    }\n    doctors {\n      id\n      publicId\n      hospitalId\n      isAbsent\n      name\n      displayName\n      medicineType\n      gender\n      profileImagePath\n      contractType\n      departmentGroups {\n        departmentGroupId\n        departmentGroupName\n        departmentGroupIconUrl\n        averageRating\n      }\n      professionalDepartmentsV2 {\n        departmentId\n        departmentName\n        departmentCode\n      }\n      careers {\n        careerType\n        content\n        id\n      }\n      reviewMetric {\n        averageRating\n        totalCount\n        groupByDiagnosisType {\n          count\n          diagnosisType\n          diagnosisTypeId\n          name\n        }\n        groupByRating {\n          count\n          rating\n        }\n      }\n      partnershipStatus\n    }\n    topRatedDoctorReviews(size: 3) {\n      content\n      createdAt\n      id\n      isPrivate\n      likeCount\n      maskedHolderName\n      rating\n      targetCategoryName\n      title\n      isBlocked\n      isLiked\n      comments {\n        content\n        createdAt\n        id\n        isBlocked\n        reviewCommentHolder {\n          id\n          name\n          profileImageUrl\n        }\n      }\n      reviewContext {\n        reviewReceiver {\n          id\n          name\n        }\n      }\n      tags {\n        id\n        reviewId\n        tag {\n          tagId\n          text\n        }\n        tagId\n      }\n    }\n  }\n}\n    ";
var useGetHospitalByIdQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetHospitalById",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetHospitalByIdDocument, "GetHospitalById", variables), options);
};
useGetHospitalByIdQuery.getKey = function(variables) {
    return [
        "GetHospitalById",
        variables
    ];
};
useGetHospitalByIdQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetHospitalByIdDocument, "GetHospitalById", variables, options);
};
var DoctorReviewMetricDocument = "\n    query DoctorReviewMetric($doctorReviewSearchRequest: DoctorReviewSearchRequestV2Input!) {\n  doctorReviewMetric(doctorReviewSearchRequest: $doctorReviewSearchRequest) {\n    totalCount\n    averageRating\n    groupByRating {\n      count\n      rating\n    }\n    groupByDiagnosisType {\n      diagnosisType\n      diagnosisTypeId\n      name\n      count\n    }\n  }\n}\n    ";
var useDoctorReviewMetricQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "DoctorReviewMetric",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(DoctorReviewMetricDocument, "DoctorReviewMetric", variables), options);
};
useDoctorReviewMetricQuery.getKey = function(variables) {
    return [
        "DoctorReviewMetric",
        variables
    ];
};
useDoctorReviewMetricQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(DoctorReviewMetricDocument, "DoctorReviewMetric", variables, options);
};
var GetFaceToFaceDiagnosisBookingFormByPublicIdDocument = "\n    query GetFaceToFaceDiagnosisBookingFormByPublicId($publicId: String!) {\n  getFaceToFaceDiagnosisBookingFormByPublicId(publicId: $publicId) {\n    hospital {\n      name\n    }\n    doctor {\n      name\n      medicineType\n    }\n    booking {\n      status\n    }\n    diagnosis {\n      status\n    }\n    bookingId\n    targetDate\n    targetDateDisplayText\n    detailSymptom\n    name\n    registrationNumber\n    address\n    detailAddress\n  }\n}\n    ";
var useGetFaceToFaceDiagnosisBookingFormByPublicIdQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetFaceToFaceDiagnosisBookingFormByPublicId",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetFaceToFaceDiagnosisBookingFormByPublicIdDocument, "GetFaceToFaceDiagnosisBookingFormByPublicId", variables), options);
};
useGetFaceToFaceDiagnosisBookingFormByPublicIdQuery.getKey = function(variables) {
    return [
        "GetFaceToFaceDiagnosisBookingFormByPublicId",
        variables
    ];
};
useGetFaceToFaceDiagnosisBookingFormByPublicIdQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetFaceToFaceDiagnosisBookingFormByPublicIdDocument, "GetFaceToFaceDiagnosisBookingFormByPublicId", variables, options);
};
var GetTotalReviewCountWithAverageRatingByPublicIdDocument = "\n    query GetTotalReviewCountWithAverageRatingByPublicId($publicId: String!) {\n  getTotalReviewCountWithAverageRatingByPublicId(publicId: $publicId) {\n    averageRating\n    totalCount\n  }\n}\n    ";
var useGetTotalReviewCountWithAverageRatingByPublicIdQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetTotalReviewCountWithAverageRatingByPublicId",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetTotalReviewCountWithAverageRatingByPublicIdDocument, "GetTotalReviewCountWithAverageRatingByPublicId", variables), options);
};
useGetTotalReviewCountWithAverageRatingByPublicIdQuery.getKey = function(variables) {
    return [
        "GetTotalReviewCountWithAverageRatingByPublicId",
        variables
    ];
};
useGetTotalReviewCountWithAverageRatingByPublicIdQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetTotalReviewCountWithAverageRatingByPublicIdDocument, "GetTotalReviewCountWithAverageRatingByPublicId", variables, options);
};
var GetAddressByLocationDocument = "\n    query GetAddressByLocation($longitude: Float!, $latitude: Float!) {\n  getAddressByLocation(longitude: $longitude, latitude: $latitude) {\n    detailAddress\n    jibunAddress\n    roadAddress\n    sido\n    zipCode\n    sigungu\n    dongLi\n  }\n}\n    ";
var useGetAddressByLocationQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetAddressByLocation",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetAddressByLocationDocument, "GetAddressByLocation", variables), options);
};
useGetAddressByLocationQuery.getKey = function(variables) {
    return [
        "GetAddressByLocation",
        variables
    ];
};
useGetAddressByLocationQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetAddressByLocationDocument, "GetAddressByLocation", variables, options);
};
var GetUserAddressesDocument = "\n    query GetUserAddresses {\n  getUserAddresses {\n    userAddressId\n    userId\n    alias\n    roadAddress\n    oldAddress\n    detailAddress\n    addressType\n    location {\n      latitude\n      longitude\n    }\n    zipCode\n    deliveryComment\n    frontDoorPassword\n    isDefault\n  }\n}\n    ";
var useGetUserAddressesQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(variables === undefined ? [
        "GetUserAddresses"
    ] : [
        "GetUserAddresses",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetUserAddressesDocument, "GetUserAddresses", variables), options);
};
useGetUserAddressesQuery.getKey = function(variables) {
    return variables === undefined ? [
        "GetUserAddresses"
    ] : [
        "GetUserAddresses",
        variables
    ];
};
useGetUserAddressesQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetUserAddressesDocument, "GetUserAddresses", variables, options);
};
var SearchKoreaAddressV2Document = "\n    query SearchKoreaAddressV2($request: KoreaAddressSearchRequestV2Input!) {\n  searchKoreaAddressV2(request: $request) {\n    centroidLatitude\n    centroidLongitude\n    displayName\n    regionCode\n    regionName\n  }\n}\n    ";
var useSearchKoreaAddressV2Query = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "SearchKoreaAddressV2",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchKoreaAddressV2Document, "SearchKoreaAddressV2", variables), options);
};
useSearchKoreaAddressV2Query.getKey = function(variables) {
    return [
        "SearchKoreaAddressV2",
        variables
    ];
};
useSearchKoreaAddressV2Query.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchKoreaAddressV2Document, "SearchKoreaAddressV2", variables, options);
};
var HospitalExternalPostDocument = "\n    query HospitalExternalPost($hospitalPublicId: ID!, $size: Int!, $pivotId: Int) {\n  hospitalExternalPost(\n    hospitalPublicId: $hospitalPublicId\n    size: $size\n    pivotId: $pivotId\n  ) {\n    totalCount\n    items {\n      id\n      title\n      content\n      postedAt\n      url\n    }\n  }\n}\n    ";
var useHospitalExternalPostQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "HospitalExternalPost",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(HospitalExternalPostDocument, "HospitalExternalPost", variables), options);
};
useHospitalExternalPostQuery.getKey = function(variables) {
    return [
        "HospitalExternalPost",
        variables
    ];
};
useHospitalExternalPostQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(HospitalExternalPostDocument, "HospitalExternalPost", variables, options);
};


/***/ }),

/***/ 18215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55351);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var _components_layouts_DefaultLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83651);
/* harmony import */ var _hooks_Cuj_useAppInstallTopBanner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72105);
/* harmony import */ var _types_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70138);
/* harmony import */ var _utils_format__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4611);
/* harmony import */ var _utils_url__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74735);
/* harmony import */ var _views_non_benefit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(59133);
// PageDescription: 지역별 비급여 가격비교 페이지










var NonBenefitHomePages = function(param) {
    var client = param.client;
    var ref;
    var viewModel = (0,_views_non_benefit__WEBPACK_IMPORTED_MODULE_9__/* .useNonBenefitHomeViewModel */ .Ef)(client);
    var topBannerViewModel = (0,_hooks_Cuj_useAppInstallTopBanner__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(client);
    var _queries = viewModel.queries, treatmentId = _queries.treatmentId, treatmentMedicineUnitId = _queries.treatmentMedicineUnitId, regionCode = _queries.regionCode;
    var title = "".concat(viewModel.selectedAddressTitle, " ").concat((ref = viewModel.selectedMedicine) === null || ref === void 0 ? void 0 : ref.medicineDescription, " 처방 최저가 병원/약국 가격(").concat(new Date().getFullYear(), ") - 닥터나우");
    var description = (0,_views_non_benefit__WEBPACK_IMPORTED_MODULE_9__/* .getDescriptionForMetaTag */ .cK)(treatmentId);
    var canonical = "".concat("https://doctornow.co.kr").concat(_types_common__WEBPACK_IMPORTED_MODULE_6__/* .ROUTES.NON_BENEFIT.HOME.path */ .Z6.NON_BENEFIT.HOME.path).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_8__/* .addQueryString */ .sC)({
        treatmentMedicineUnitId: treatmentMedicineUnitId,
        regionCode: regionCode
    }));
    var nonBenefitLdJson = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return (0,_utils_format__WEBPACK_IMPORTED_MODULE_7__/* .nonBenefitSeoLdJson */ .r3)({
            doctors: viewModel.nonBenefitDoctors,
            address: viewModel.selectedAddressTitle,
            faqs: viewModel.faqs,
            canonical: canonical
        });
    }, [
        viewModel.selectedMedicine
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
                title: title,
                description: description,
                canonical: canonical,
                openGraph: {
                    title: title,
                    description: description,
                    url: canonical,
                    images: [
                        {
                            url: "".concat("https://doctornow-front-images.s3.ap-northeast-2.amazonaws.com/og-main.png"),
                            alt: "Og Image Alt"
                        }, 
                    ]
                },
                additionalMetaTags: (0,_views_non_benefit__WEBPACK_IMPORTED_MODULE_9__/* .getAdditionalMetaTags */ ._2)(treatmentId)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(nonBenefitLdJson)
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_views_non_benefit__WEBPACK_IMPORTED_MODULE_9__/* .NonBenefitHomeView */ .Gl, {
                client: client,
                viewModel: viewModel,
                topBannerViewModel: topBannerViewModel
            })
        ]
    });
};
NonBenefitHomePages.Layout = _components_layouts_DefaultLayout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z;
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (NonBenefitHomePages);


/***/ }),

/***/ 15951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ep": function() { return /* binding */ appInstallTopBannerState; },
/* harmony export */   "Ih": function() { return /* binding */ setAppDownloadCujModalState; },
/* harmony export */   "Ze": function() { return /* binding */ appDownloadCujModalState; },
/* harmony export */   "_l": function() { return /* binding */ getAppInstallTopBannerState; },
/* harmony export */   "dl": function() { return /* binding */ hideBanner; }
/* harmony export */ });
/* unused harmony exports CujTestDateState, getCujTestDateState, setCujTestDateState, setBannerState */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53476);
/* harmony import */ var recoil_nexus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89430);
/* harmony import */ var _utils_atom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80888);




var CujTestDateState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "testDate",
    default: [],
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_2__/* .localStorageEffect */ .N)("testCujDate")
    ]
});
var getCujTestDateState = function() {
    return getRecoil(CujTestDateState);
};
var setCujTestDateState = function(date) {
    setRecoil(CujTestDateState, date);
};
var appDownloadCujModalState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "appDownloadCujModalState",
    default: {
        isShow: false
    },
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_2__/* .sessionStorageEffect */ .j)("appDownLoadCujModal")
    ]
});
var appInstallTopBannerState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "appInstallTopBannerStateType",
    default: {
        isVisible: false,
        expirationTime: undefined
    },
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_2__/* .sessionStorageEffect */ .j)("appInstallTopBanner")
    ]
});
var setAppDownloadCujModalState = function(state) {
    (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .setRecoil */ .z8)(appDownloadCujModalState, function(current) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, current, state);
    });
};
var getAppInstallTopBannerState = function() {
    var state = (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .getRecoil */ .$l)(appInstallTopBannerState);
    if (state.expirationTime === undefined) {
        setBannerState({
            isVisible: true,
            expirationTime: undefined
        });
    }
    if (state.expirationTime && new Date() > new Date(state.expirationTime)) {
        setBannerState({
            isVisible: true,
            expirationTime: undefined
        });
    }
    return state;
};
// 배너 상태를 설정하는 함수
var setBannerState = function(state) {
    (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .setRecoil */ .z8)(appInstallTopBannerState, function(current) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, current, state);
    });
};
var hideBanner = function() {
    var expirationTime = new Date(new Date().getTime() + 30 * 60 * 1000).toISOString(); // 30분
    setBannerState({
        isVisible: false,
        expirationTime: expirationTime
    });
};


/***/ }),

/***/ 23144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ SearchHospitalService; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70865);
/* harmony import */ var _constants_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13805);



var SearchHospitalService = /*#__PURE__*/ function() {
    "use strict";
    function SearchHospitalService() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, SearchHospitalService);
    }
    SearchHospitalService.updateCoordinate = function updateCoordinate(coordinate, updatedCoordinate) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, coordinate, updatedCoordinate);
    };
    SearchHospitalService.initializeUserSigunguDongli = function initializeUserSigunguDongli() {
        return {
            sigungu: "서초구",
            dongLi: "서초동"
        };
    };
    SearchHospitalService.initializeUserCoordinate = function initializeUserCoordinate() {
        return {
            latitude: _constants_map__WEBPACK_IMPORTED_MODULE_2__/* .DOCTOR_NOW_COMPANY_LATITUDE */ .q,
            longitude: _constants_map__WEBPACK_IMPORTED_MODULE_2__/* .DOCTOR_NOW_COMPANY_LONGITUDE */ .y
        };
    };
    SearchHospitalService.parseGetAddressByLocation = function parseGetAddressByLocation(data) {
        if (!data.getAddressByLocation) {
            return null;
        }
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, data.getAddressByLocation);
    };
    SearchHospitalService.parseHospitalAddressByLocation = function parseHospitalAddressByLocation(data) {
        var hospitalAddress = SearchHospitalService.parseGetAddressByLocation(data);
        if (!hospitalAddress) {
            return SearchHospitalService.initializeUserSigunguDongli();
        }
        return {
            sigungu: hospitalAddress.sigungu,
            dongLi: hospitalAddress.dongLi
        };
    };
    SearchHospitalService.parseKoreaAddressV2 = function parseKoreaAddressV2(data) {
        return data.searchKoreaAddressV2.map(function(address) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, address);
        });
    };
    return SearchHospitalService;
}();


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1498,4998,5615,1743,9535,5243,8652,5247,5203,1960,1539,3153,9133,9774,2888,179], function() { return __webpack_exec__(45971); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);